/** Guest HTTP Basic credentials for GET /api/v1/preview (PREVIEWER role). */
export const RESULT_PREVIEW_BASIC_USERNAME = "ht_previewer";
export const RESULT_PREVIEW_BASIC_PASSWORD = "6d2sd@51%";
